import { render } from "./Sign-in.vue?vue&type=template&id=4fd87008"
import script from "./Sign-in.vue?vue&type=script&lang=js"
export * from "./Sign-in.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__